import { Action } from 'redux'
import { SynchronizeActions } from '../../reducers/synchronize/actionNames'

export const requestSynchronization = (): ISynchronizeAction => ({
  type: SynchronizeActions.StartSync,
})

export const synchronizationCompleted = (
  lastModifyDate: Date,
): ISyncCompleted => ({
  lastModifyDate,
  type: SynchronizeActions.SyncCompleted,
})

export const synchronizationRejected = (): ISyncRejected => ({
  type: SynchronizeActions.SyncRejected,
})

export const changesDetected = (lastModifyDate: Date): IChangesDetected => ({
  lastModifyDate,
  type: SynchronizeActions.NewChanges,
})

export const requestFirstSync = (): IFirstSynchronization => ({
  type: SynchronizeActions.FirstSync,
})

export const requestContinuousSync = (): Action<SynchronizeActions.RequestContinuousSync> => ({
  type: SynchronizeActions.RequestContinuousSync,
})

export type ISynchronizeAction = Action<SynchronizeActions.StartSync>

export interface ISyncCompleted
  extends Action<SynchronizeActions.SyncCompleted> {
  lastModifyDate: Date
}

export type ISyncRejected = Action<SynchronizeActions.SyncRejected>

export interface IChangesDetected
  extends Action<SynchronizeActions.NewChanges> {
  lastModifyDate: Date
}

export type IFirstSynchronization = Action<SynchronizeActions.FirstSync>
